import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'la-toast',
  template: `
    <div class="la-toast">
      <div class="la-toast__icon">
        <ng-content select="la-icon"></ng-content>
      </div>
      <div class="la-toast__text">
        <ng-content select="la-text"></ng-content>
      </div>
    </div>
  `,
  styles: [`
    .la-toast{width:123px;height:123px;border-radius:79px;box-shadow:0 2px 20px 0 rgba(54,68,79,.1);background-color:rgba(3,20,34,.8);position:relative}.la-toast .la-toast__icon{position:absolute;top:20px;left:45px;text-align:center}.la-toast .la-toast__text{position:absolute;top:50px;padding:0 20px;text-align:center}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaToastComponent { }
